import type * as Types from "../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetProfileForAvailabilityQueryVariables = Types.Exact<{
  input: Types.GetProfileInput;
}>;

export type GetProfileForAvailabilityQuery = {
  __typename?: "Query";
  getProfile: {
    __typename?: "Profile";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
    primaryImage: string | null;
    email: string | null;
  };
};

export type ProfileForAvailabilityFragment = {
  __typename?: "Profile";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
  primaryImage: string | null;
  email: string | null;
};

export type GetWorkingHoursQueryVariables = Types.Exact<{
  input: Types.GetWorkingHoursInput;
}>;

export type GetWorkingHoursQuery = {
  __typename?: "Query";
  getWorkingHours: Array<{
    __typename?: "WorkingHour";
    dayOfTheWeek: Types.DayOfTheWeek;
    startTime: string;
    endTime: string;
  }>;
};

export type WorkingHourFragment = {
  __typename?: "WorkingHour";
  dayOfTheWeek: Types.DayOfTheWeek;
  startTime: string;
  endTime: string;
};

export type SaveWorkingHoursMutationVariables = Types.Exact<{
  input: Types.SaveWorkingHoursInput;
}>;

export type SaveWorkingHoursMutation = {
  __typename?: "Mutation";
  saveWorkingHours: { __typename?: "SuccessResponse"; success: boolean };
};

export type DeleteAllWorkingHoursMutationVariables = Types.Exact<{
  input: Types.DeleteAllWorkingHoursInput;
}>;

export type DeleteAllWorkingHoursMutation = {
  __typename?: "Mutation";
  deleteAllWorkingHours: { __typename?: "SuccessResponse"; success: boolean };
};

export const ProfileForAvailabilityFragmentDoc = gql`
  fragment ProfileForAvailability on Profile {
    userUuid
    firstName
    lastName
    primaryImage
    email
  }
`;
export const WorkingHourFragmentDoc = gql`
  fragment WorkingHour on WorkingHour {
    dayOfTheWeek
    startTime
    endTime
  }
`;
export const GetProfileForAvailabilityDocument = gql`
  query GetProfileForAvailability($input: GetProfileInput!) {
    getProfile(getProfileInput: $input) {
      ...ProfileForAvailability
    }
  }
  ${ProfileForAvailabilityFragmentDoc}
`;

/**
 * __useGetProfileForAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetProfileForAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileForAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileForAvailabilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProfileForAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileForAvailabilityQuery,
    GetProfileForAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProfileForAvailabilityQuery,
    GetProfileForAvailabilityQueryVariables
  >(GetProfileForAvailabilityDocument, options);
}
export function useGetProfileForAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileForAvailabilityQuery,
    GetProfileForAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProfileForAvailabilityQuery,
    GetProfileForAvailabilityQueryVariables
  >(GetProfileForAvailabilityDocument, options);
}
export type GetProfileForAvailabilityQueryHookResult = ReturnType<
  typeof useGetProfileForAvailabilityQuery
>;
export type GetProfileForAvailabilityLazyQueryHookResult = ReturnType<
  typeof useGetProfileForAvailabilityLazyQuery
>;
export type GetProfileForAvailabilityQueryResult = Apollo.QueryResult<
  GetProfileForAvailabilityQuery,
  GetProfileForAvailabilityQueryVariables
>;
export const GetWorkingHoursDocument = gql`
  query GetWorkingHours($input: GetWorkingHoursInput!) {
    getWorkingHours(input: $input) {
      ...WorkingHour
    }
  }
  ${WorkingHourFragmentDoc}
`;

/**
 * __useGetWorkingHoursQuery__
 *
 * To run a query within a React component, call `useGetWorkingHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkingHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkingHoursQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkingHoursQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkingHoursQuery,
    GetWorkingHoursQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkingHoursQuery, GetWorkingHoursQueryVariables>(
    GetWorkingHoursDocument,
    options,
  );
}
export function useGetWorkingHoursLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkingHoursQuery,
    GetWorkingHoursQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkingHoursQuery,
    GetWorkingHoursQueryVariables
  >(GetWorkingHoursDocument, options);
}
export type GetWorkingHoursQueryHookResult = ReturnType<
  typeof useGetWorkingHoursQuery
>;
export type GetWorkingHoursLazyQueryHookResult = ReturnType<
  typeof useGetWorkingHoursLazyQuery
>;
export type GetWorkingHoursQueryResult = Apollo.QueryResult<
  GetWorkingHoursQuery,
  GetWorkingHoursQueryVariables
>;
export const SaveWorkingHoursDocument = gql`
  mutation SaveWorkingHours($input: SaveWorkingHoursInput!) {
    saveWorkingHours(input: $input) {
      success
    }
  }
`;
export type SaveWorkingHoursMutationFn = Apollo.MutationFunction<
  SaveWorkingHoursMutation,
  SaveWorkingHoursMutationVariables
>;

/**
 * __useSaveWorkingHoursMutation__
 *
 * To run a mutation, you first call `useSaveWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkingHoursMutation, { data, loading, error }] = useSaveWorkingHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWorkingHoursMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveWorkingHoursMutation,
    SaveWorkingHoursMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveWorkingHoursMutation,
    SaveWorkingHoursMutationVariables
  >(SaveWorkingHoursDocument, options);
}
export type SaveWorkingHoursMutationHookResult = ReturnType<
  typeof useSaveWorkingHoursMutation
>;
export type SaveWorkingHoursMutationResult =
  Apollo.MutationResult<SaveWorkingHoursMutation>;
export type SaveWorkingHoursMutationOptions = Apollo.BaseMutationOptions<
  SaveWorkingHoursMutation,
  SaveWorkingHoursMutationVariables
>;
export const DeleteAllWorkingHoursDocument = gql`
  mutation DeleteAllWorkingHours($input: DeleteAllWorkingHoursInput!) {
    deleteAllWorkingHours(input: $input) {
      success
    }
  }
`;
export type DeleteAllWorkingHoursMutationFn = Apollo.MutationFunction<
  DeleteAllWorkingHoursMutation,
  DeleteAllWorkingHoursMutationVariables
>;

/**
 * __useDeleteAllWorkingHoursMutation__
 *
 * To run a mutation, you first call `useDeleteAllWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllWorkingHoursMutation, { data, loading, error }] = useDeleteAllWorkingHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllWorkingHoursMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAllWorkingHoursMutation,
    DeleteAllWorkingHoursMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAllWorkingHoursMutation,
    DeleteAllWorkingHoursMutationVariables
  >(DeleteAllWorkingHoursDocument, options);
}
export type DeleteAllWorkingHoursMutationHookResult = ReturnType<
  typeof useDeleteAllWorkingHoursMutation
>;
export type DeleteAllWorkingHoursMutationResult =
  Apollo.MutationResult<DeleteAllWorkingHoursMutation>;
export type DeleteAllWorkingHoursMutationOptions = Apollo.BaseMutationOptions<
  DeleteAllWorkingHoursMutation,
  DeleteAllWorkingHoursMutationVariables
>;
